import promocodes from './promocodes'
import discountcodes from './discountcodes'
import {CLIENT_PROMO_CODES, CLIENT_DISCOUNT_CODES} from './siteIds'

const APP_CONFIG = {
  [CLIENT_PROMO_CODES]: promocodes,
  [CLIENT_DISCOUNT_CODES]: discountcodes,
}

export default APP_CONFIG
